<template>
  <router-link v-if="object.doctor"
               :to="{ name: 'StaffDoctorVisits', params: {id: object.doctor.id }}">
    <img class="doctor-img mr-2"
         :style="`border-color: ${object.doctor.color}`"
         :src="object.doctor.photo"
         :alt="object.doctor.full_name"
         :title="object.doctor.full_name"/>{{ object.doctor.full_name }}
  </router-link>
</template>

<script>
export default {
  name: "PatientsDatatableTDDoctorName",
  props: {
    object: {
      type: Object
    }
  },
}
</script>

<style scoped lang="scss">
  .doctor-img {
    border-radius: 100%;
    width: 36px;
    height: 36px;
    border-width: 3px;
    border-style: solid;
    border-color: #000;
  }
</style>
